var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import globalStyles from "@bookingcom/bui-core/css/BUIProvider.module.css";
import { classNames, responsiveClassNames, } from "@bookingcom/bui-core/utilities/classNames";
import mixinClassNames from "../../utilities/mixinClassNames.js";
import { mixinStyles } from "@bookingcom/bui-core/utilities/styles";
import { mapResponsiveProps } from "@bookingcom/bui-core/utilities/responsive";
import CheckmarkSelectedIcon from "@bookingcom/bui-assets-react/streamline/CheckmarkSelectedIcon";
import WarningIcon from "@bookingcom/bui-assets-react/streamline/WarningIcon";
import Button from "../Button/index.js";
import Stack from "../Stack/index.js";
import Icon, {} from "../Icon/index.js";
import Text, {} from "../Text/index.js";
import styles from "@bookingcom/bui-core/css/Alert.module.css";
var colorMap = {
    success: {
        textColor: "constructive",
        iconColor: "constructive",
    },
    error: {
        textColor: "destructive",
        iconColor: "destructive",
    },
};
var Alert = function (props) {
    var text = props.text, title = props.title, actions = props.actions, variant = props.variant, _a = props.inline, inline = _a === void 0 ? false : _a, className = props.className, attributes = props.attributes, bleed = props.bleed, children = props.children, _b = props.titleTagName, titleTagName = _b === void 0 ? "span" : _b, mixin = props.mixin;
    var rootClassNames = classNames(styles.root, variant && styles["root--variant-".concat(variant)], responsiveClassNames(styles, "root--inline", inline), bleed && globalStyles["bui-u-bleed--small"], className, mixinClassNames(mixin));
    var rootAttributes = __assign(__assign({}, attributes), { style: __assign(__assign({}, ((attributes === null || attributes === void 0 ? void 0 : attributes.style) || {})), mixinStyles(mixin)) });
    var rootGap = mapResponsiveProps(inline, {
        true: 2,
        false: 4,
    });
    var renderIcon = function () {
        var colorSet = colorMap[variant];
        var iconSVG = {
            success: CheckmarkSelectedIcon,
            error: WarningIcon,
        }[variant];
        var iconSize = mapResponsiveProps(inline, {
            true: "small",
            false: "medium",
        });
        var iconClassNames = classNames(styles.icon, !title && !!text && styles["icon--no-title"]);
        return (React.createElement("span", { className: iconClassNames },
            React.createElement(Icon, { svg: iconSVG, size: iconSize, color: colorSet.iconColor })));
    };
    var renderContent = function () {
        return (React.createElement(Stack, { gap: 2 },
            (title || text) && (React.createElement(Stack.Item, null,
                title && (React.createElement(Text, { tagName: titleTagName, className: styles.title, variant: "strong_1" }, title)),
                text && (React.createElement(Text, { tagName: "p", className: styles.text }, text)))),
            children && React.createElement(Text, { color: "neutral" }, children),
            actions && (React.createElement(Stack, { direction: "row", gap: 3 }, actions.map(function (action, index) { return (React.createElement(Button.Aligner, { alignment: ["start", "bottom"], key: action.text || index },
                React.createElement(Button, __assign({}, action, { variant: "tertiary" })))); })))));
    };
    return (React.createElement("div", __assign({ className: rootClassNames, role: variant === "error" ? "alert" : "status" }, rootAttributes),
        React.createElement(Stack, { direction: "row", gap: rootGap },
            renderIcon(),
            React.createElement(Stack.Item, { grow: true }, renderContent()))));
};
export default Alert;
